import React from "react";
import ReactDOM from "react-dom/client";
import SensorFusionHeavyMachinery from "./sensor-fusion-heavy-machinery";
import "../../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SensorFusionHeavyMachinery />
  </React.StrictMode>,
);
